import React from 'react'
import { ArrowShortLeftCenteredIcon, ArrowShortRightCenteredIcon } from '@fourthwall/icons'
import { Icon } from '../Icon'

import * as S from './styled'

type ArrowsButtonProps = {
  direction: 'prev' | 'next'
  disabled: boolean
  size?: 'small' | 'medium'
  onClick: () => void
}

export const ArrowsButton = ({
  direction,
  disabled,
  size = 'medium',
  onClick,
}: ArrowsButtonProps) => {
  const iconHeight = { small: 12, medium: 14 }[size]

  return (
    <S.Button disabled={disabled} onClick={onClick}>
      {direction === 'prev' && <Icon component={ArrowShortLeftCenteredIcon} height={iconHeight} />}
      {direction === 'next' && <Icon component={ArrowShortRightCenteredIcon} height={iconHeight} />}
    </S.Button>
  )
}
